var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageHeader',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"title":_vm.title || _vm.defaultTitle}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }